/* __next_internal_client_entry_do_not_use__ NotifyMeBackInStockButton auto */ import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useState } from "react";
import { RoundNotifyMeButton } from "@faire/retailer/components/RoundNotifyMeButton";
import { NotifyMeWrapper } from "@faire/retailer/features/MarketplaceItems/styled";
export var NotifyMeBackInStockButton = function(param) {
    var productOptionToken = param.productOptionToken, productToken = param.productToken, isSubscribedToBackInStockNotification = param.isSubscribedToBackInStockNotification;
    var _useState = _sliced_to_array(useState(isSubscribedToBackInStockNotification), 2), isSubscribedToBackInStock = _useState[0], setIsSubsribedToBackInStock = _useState[1];
    var deleteBackInStockNotification = useCallback(function(optionToken) {
        setIsSubsribedToBackInStock(productOptionToken === optionToken ? false : true);
    }, [
        productOptionToken
    ]);
    var preventClickEvents = function(e) {
        e.preventDefault();
        e.stopPropagation();
    };
    return /*#__PURE__*/ _jsx(NotifyMeWrapper, {
        onClick: function(e) {
            return preventClickEvents(e);
        },
        children: /*#__PURE__*/ _jsx(RoundNotifyMeButton, {
            productOptionToken: productOptionToken !== null && productOptionToken !== void 0 ? productOptionToken : "",
            isSubscriedToBackInStock: isSubscribedToBackInStock,
            deleteBackInStockNotification: deleteBackInStockNotification
        })
    }, "".concat(productToken, "-round-notify-me-picker"));
};
